import { render, staticRenderFns } from "./SmileFaces.vue?vue&type=template&id=b399de12&scoped=true&"
import script from "./SmileFaces.vue?vue&type=script&lang=js&"
export * from "./SmileFaces.vue?vue&type=script&lang=js&"
import style0 from "./SmileFaces.vue?vue&type=style&index=0&id=b399de12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b399de12",
  null
  
)

export default component.exports